<template>
  <div>
    <b-card no-body>
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <div>
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Bộ lọc"
                class="border border-primary rounded p-50"
                label-class="pb-25"
              >
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    lg="6"
                    xl="6"
                  >
                    <b-form-group
                      label-for="trainingSystemsSelected"
                    >
                      <v-select
                        v-model="trainingSystemsSelected"
                        :options="trainingSystemsOptions"
                        :reduce="option => option.value"
                        label="label"
                        placeholder="Loại hình đào tạo"
                        @input="onChangeTrainingSystems"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    lg="6"
                    xl="6"
                  >
                    <b-form-group
                      label-for="coursesSelected"
                    >
                      <v-select
                        v-model="coursesSelected"
                        :options="coursesOptions"
                        :reduce="option => option.value"
                        label="label"
                        placeholder="Khóa học"
                        @input="onChangeCourses"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    lg="6"
                    xl="6"
                  >
                    <b-form-group
                      label-for="semestersSelect"
                    >
                      <v-select
                        v-model="semestersSelect"
                        :options="semestersOptions"
                        :reduce="option => option.value"
                        label="label"
                        placeholder="Kỳ học"
                        @input="onChangeSemesters"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    lg="6"
                    xl="6"
                  >
                    <b-form-group
                      label-for="majorsSelect"
                    >
                      <v-select
                        v-model="majorsSelect"
                        :options="majorsOptions"
                        :reduce="option => option.value"
                        label="label"
                        placeholder="Ngành"
                        @input="onChangeMajors"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    lg="6"
                    xl="6"
                  >
                    <b-form-group
                      label-for="policiesSelect"
                    >
                      <v-select
                        v-model="policiesSelect"
                        :options="policiesOptions"
                        :reduce="option => option.value"
                        label="label"
                        placeholder="Đối tượng"
                        @input="onChangePolicies"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="text-right mb-2">
                <b-button
                  v-show="creatable"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  v-b-modal.exemptionSaveModal
                  variant="success"
                  class="ml-1"
                  @click="onCreate"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="14"
                    class="mr-50"
                  />
                  <span class="text-nowrap text-right">Tạo mới</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="ml-1"
                  @click="onSelect"
                >
                  <feather-icon
                    icon="ListIcon"
                    size="14"
                    class="mr-50"
                  />
                  <span class="text-nowrap text-right">Danh sách</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12">
              <vue-good-table
                mode="remote"
                class="my-table"
                style-class="vgt-table striped bordered research-table"
                row-style-class="vgt-row"
                :columns="columns"
                :rows="listExemptions"
                :pagination-options="paginationOptions"
                :total-rows="totalRows"
                line-numbers
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
              >
                <div
                  slot="emptystate"
                  style="text-align: center; font-weight: bold"
                >
                  Không có bản ghi nào !
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span v-if="props.column.field === 'stt'">
                    {{ props.row.originalIndex + 1 }}
                  </span>
                  <span v-else-if="props.column.field === 'amount'">
                    {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(props.row.amount) }}
                  </span>
                  <span v-else-if="props.column.field === 'action'">
                    <b-button
                      v-if="updatable"
                      v-b-modal.exemptionSaveModal
                      variant="primary"
                      class="btn-icon"
                      size="sm"
                      @click="onEditExemption(props.row)"
                    >
                      <feather-icon icon="Edit2Icon" />
                    </b-button>
                    <b-button
                      v-if="deletable"
                      variant="danger"
                      class="btn-icon"
                      style="margin-left: 6px"
                      size="sm"
                      @click="onDeleteExemption(props.row)"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </span>

                  <!-- Column: Common -->
                  <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                </template>

                <!-- pagination -->
                <template
                  slot="pagination-bottom"
                  slot-scope="props"
                >
                  <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                      <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                        đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-0 mt-1">
                      <span class="text-nowrap"> Hiển thị </span>
                      <b-form-select
                        v-model="filter.itemsPerPage"
                        :options="itemsPerPageOptions"
                        class="mx-1"
                        @input="(value) => props.perPageChanged({ currentPerPage: value })"
                      />
                      <span class="text-nowrap"> bản ghi/trang</span>
                    </div>
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="totalRows"
                        :per-page="filter.itemsPerPage"
                        class="mt-1 mb-0"
                        @input="(value) => props.pageChanged({ currentPage: value })"
                      />
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
    <exemptionSave
      ref="exemptionsSaveFormRef"
      :exemption="currentExemptions"
      @succeed="onSucceed"
    />
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BContainer, BFormGroup, BFormSelect, BOverlay, BPagination, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import { showSuccessToast, showErrorToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import exemptionSave from '@/views/finance/exemption/ExemptionSave.vue'
import vSelect from 'vue-select'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import { getUser } from '@/auth/utils'

export default {
  name: 'Exemption',
  directives: {
    Ripple,
  },
  components: {
    exemptionSave,
    BFormGroup,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
    vSelect,
  },
  data() {
    return {
      user: getUser(),
      trainingSystemsSelected: undefined,
      coursesSelected: undefined,
      semestersSelect: undefined,
      majorsSelect: null,
      policiesSelect: null,
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        name: '',
        organization_id: getUser().orgId,
        training_system_id: null,
        course_id: null,
        semester_id: null,
        major_id: null,
        policies_id: null,
        sort: '',
      },
      currentExemptions: {
        training_system_id: null,
        course_id: null,
        semester_id: null,
        major_id: null,
        revenue_id: null,
        amount: null,
        course_semester_id: null,
        policies_id: null,
        id: null,
      },
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'Khoản thu được miễn giảm',
          field: 'revenue_name',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Số tiền',
          field: 'amount',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Đối tượng',
          field: 'policies_name',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Kỳ học',
          field: 'semester_name',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Ngành',
          field: 'major_name',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      listExemptions: 'exemption/listExemptions',
      totalRows: 'exemption/totalRows',
      allTrainingSystems: 'exemption/allTrainingSystems',
      allMajors: 'exemption/allMajors',
      allPolicies: 'exemption/allPolicies',
      listCourses: 'exemption/listCourses',
      listSemesters: 'exemption/listSemesters',
    }),
    trainingSystemsOptions() {
      return this.allTrainingSystems.map(item => ({ value: item.id, label: item.name }))
    },
    coursesOptions() {
      return this.listCourses.map(item => ({ value: item.id, label: item.name }))
    },
    semestersOptions() {
      return this.listSemesters.map(item => ({ value: item.id, label: item.name }))
    },
    majorsOptions() {
      return this.allMajors.map(item => ({ value: item.id, label: item.name }))
    },
    policiesOptions() {
      return this.allPolicies.map(item => ({ value: item.id, label: item.name }))
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.EXEMPTION)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.EXEMPTION)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.EXEMPTION)
    },
  },
  async created() {
    // Load initial data (training systems, majors, policies, etc.) but not exemptions list
    // Exemptions list will be loaded when tab is activated or when user clicks "Danh sách"
    try {
      await this.begin()
    } catch (e) {
      showErrorToast(this, e)
    }
  },
  methods: {
    ...mapActions({
      begin: 'exemption/begin',
      getExemptions: 'exemption/getExemptions',
      getCourses: 'exemption/getCourses',
      getSemesters: 'exemption/getSemesters',
      deleteExemption: 'exemption/deleteExemption',
    }),
    onCreate() {
      this.currentExemptions.amount = null
      this.currentExemptions.id = null
      this.currentExemptions.revenue_id = null
      this.currentExemptions.policies_id = this.policiesSelect
      this.currentExemptions.major_id = this.majorsSelect
    },
    async onSelect() {
      this.isLoading = true
      try {
        await this.getExemptions(this.filter)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    onChangeTrainingSystems() {
      if (this.trainingSystemsSelected == null) {
        this.reset()
        this.$store.commit('exemption/SET_COURSES', { data: [] })
        this.$store.commit('exemption/SET_SEMESTERS', { data: [] })
        this.coursesSelected = null
        this.semestersSelect = null
        this.currentExemptions.course_semester_id = null
        this.filter.course_id = null
        this.filter.semester_id = null
      } else {
        this.currentExemptions.training_system_id = this.trainingSystemsSelected
        this.getCourses({
          training_system_id: this.trainingSystemsSelected,
        })
      }
      this.filter.training_system_id = this.trainingSystemsSelected
    },
    onChangeCourses() {
      if (this.coursesSelected == null) {
        this.reset()
        this.$store.commit('exemption/SET_SEMESTERS', { data: [] })
        this.semestersSelect = null
        this.currentExemptions.course_semester_id = null
        this.filter.course_id = null
        this.filter.semester_id = null
      } else {
        this.currentExemptions.course_id = this.coursesSelected
        this.filter.course_id = this.coursesSelected
        this.getSemesters({
          courses_id: this.coursesSelected,
        })
      }
    },
    onChangeSemesters() {
      if (this.semestersSelect == null) {
        this.reset()
        this.currentExemptions.course_semester_id = null
        this.filter.semester_id = null
      } else {
        this.currentExemptions.semester_id = this.semestersSelect
        this.filter.semester_id = this.semestersSelect
        const item = this.listSemesters.find(x => x.id === this.semestersSelect)
        this.currentExemptions.course_semester_id = item.courses_semesters_id
      }
    },
    onChangePolicies() {
      if (this.policiesSelect == null) {
        this.reset()
        this.filter.policies_id = null
      } else {
        this.currentExemptions.policies_id = this.policiesSelect
        this.filter.policies_id = this.policiesSelect
      }
    },
    onChangeMajors() {
      if (this.majorsSelect == null) {
        this.reset()
        this.filter.major_id = null
      } else {
        this.currentExemptions.major_id = this.majorsSelect
        this.filter.major_id = this.majorsSelect
      }
    },
    reset() {
      this.$store.commit('exemption/SET_EXEMPTIONS', { total: 0, records: [] })
    },
    onEditExemption(exemption) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = exemption
      this.currentExemptions = { ...this.currentExemptions, ...rest }
    },
    onDeleteExemption(exemption) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa khoản thu miễn giảm <span class="text-danger">${exemption.revenue_name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteExemption(exemption.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                try {
                  await this.getExemptions(this.filter)
                } catch (e) {
                  showErrorToast(this, e)
                }
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getExemptionsFromStore()
    },
    async getExemptionsFromStore() {
      this.isLoading = true
      try {
        await this.getExemptions(this.filter)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getExemptionsFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParams({ sort: `1_${type}` })
      }
      await this.getExemptionsFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      await this.getExemptionsFromStore()
    },

    async onSucceed() {
      await this.getExemptionsFromStore()
      // Emit event to notify parent component
      this.$emit('data-updated', 'exemption')
    },
    async refreshData() {
      // Method to refresh data, can be called from parent
      // Also refresh initial data if needed
      this.isLoading = true
      try {
        await this.begin()
        // Optionally refresh exemptions if filter is set
        if (this.filter.training_system_id || this.filter.course_id || this.filter.semester_id) {
          await this.getExemptionsFromStore()
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.p-50 {
  padding: 0.5rem !important;
}

.pb-25 {
  padding-bottom: 0.25rem !important;
}

.mr-50 {
  margin-right: 0.5rem;
}
</style>
